import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { QrMedia } from "../public/qr/QrMedia";

const INTERVAL = 2000;

export const OfferCarousel = ({ banners = [], onOpen, paused = false }) => {
  const [i, setI] = useState(0);
  const touch = useRef(null);
  const moved = useRef(false);
  const n = banners.length;

  useEffect(() => { if (i >= n) setI(0); }, [n, i]);
  useEffect(() => {
    if (n < 2 || paused) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), INTERVAL);
    return () => clearInterval(t);
  }, [n, paused]);

  if (!n) return null;
  const go = (d) => setI((x) => (x + d + n) % n);
  const onStart = (e) => { touch.current = e.touches[0].clientX; moved.current = false; };
  const onMove = (e) => { if (touch.current != null && Math.abs(e.touches[0].clientX - touch.current) > 10) moved.current = true; };
  const onEnd = (e) => {
    if (touch.current == null) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    touch.current = null;
  };
  const click = (b) => { if (!moved.current) onOpen?.(b); };

  return (
    <section className="qr-banners" aria-label="Offers" data-testid="offer-carousel" style={{ position: "relative", overflow: "hidden", display: "block" }}>
      <div onTouchStart={onStart} onTouchMove={onMove} onTouchEnd={onEnd}
        style={{ display: "flex", transition: "transform .45s ease", transform: `translateX(-${i * 100}%)` }} data-testid="offer-track">
        {banners.map((b, idx) => (
          <button type="button" key={b.id || idx} className="qr-banner" onClick={() => click(b)} data-testid={`offer-banner-${b.id || idx}`}
            style={{ flex: "0 0 100%", maxWidth: "100%", margin: 0 }} aria-label={b.title || "Offer"} aria-hidden={idx !== i}>
            <QrMedia src={b.image_url} alt={b.title || "Offer"} size="large" className="qr-banner-photo" />
            {b.title && <span className="qr-banner-caption">{b.title}</span>}
          </button>
        ))}
      </div>
      {n > 1 && (
        <>
          <button type="button" className="qr-icon-button" onClick={() => go(-1)} aria-label="Previous offer" data-testid="offer-prev" style={{ position: "absolute", left: 8, top: "50%", transform: "translateY(-50%)", background: "rgba(255,255,255,.85)" }}><ChevronLeft size={18} /></button>
          <button type="button" className="qr-icon-button" onClick={() => go(1)} aria-label="Next offer" data-testid="offer-next" style={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)", background: "rgba(255,255,255,.85)" }}><ChevronRight size={18} /></button>
          <div style={{ display: "flex", justifyContent: "center", gap: 6, marginTop: 8 }} data-testid="offer-dots">
            {banners.map((_, idx) => <button type="button" key={idx} onClick={() => setI(idx)} aria-label={`Offer ${idx + 1}`} data-testid={`offer-dot-${idx}`}
              style={{ width: idx === i ? 18 : 7, height: 7, borderRadius: 7, border: 0, background: idx === i ? "var(--qr-red)" : "#d1d5db", transition: "width .3s" }} />)}
          </div>
        </>
      )}
    </section>
  );
};
